import { createContext, useContext } from 'react';

/**
 * Ligado no template do PDF: os gráficos desenham sem animação (o
 * html2canvas fotografaria a animação no meio) e os nomes saem sem link.
 */
export const StatsPrintContext = createContext(false);

export const useStatsPrint = () => useContext(StatsPrintContext);
